export default __webpack_public_path__ + "static/media/Global-Reach.90e22240.png";